import React, { useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { cn } from "@/src/lib/utils";

import Button from "../../button/Button";
import { Tabs, TabsList, TabsTrigger } from "../../ui/tabs";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../ui/accordion";

function UsersAdminCardModal({ users, t }) {
  const [value, setValue] = useState(0);
  const [statusCount, setStatusCount] = useState(0);

  useEffect(() => {
    getStatusCount();
  }, []);

  const renderPanel = (index) => {
    const visible_objects = [];

    users.map((user) => {
      if (
        (index === 0 && user.status === "created") ||
        (index === 1 && user.status === "already_exist") ||
        (index === 2 &&
          (user.status === "error" || user.status === "invalid_custom_values"))
      ) {
        visible_objects.push(user);
      }
    });

    return (
      <div className="editor-user-items-container w-full">
        <Accordion type="multiple" className="w-full">
          {visible_objects.map((obj, index) => (
            <AccordionItem value={obj?.email} key={obj?.email}>
              <AccordionTrigger className="cursor-pointer hover:no-underline">
                {obj?.email}
              </AccordionTrigger>
              <AccordionContent>
                {obj.status === "created" && getCreatedDetails(obj)}
                {obj.status === "already_exist" && getDuplicateDetails(obj)}
                {obj.status === "invalid_custom_values" && getErrorDetails(obj)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    );
  };

  const getDuplicateDetails = (item) => (
    <div className="flex items-center gap-3">
      {item.first_name} {item.last_name}
      {item?.uuid && (
        <Link to={`users/edit/${item?.uuid}`} target="_blank">
          <Button type="button" size="xs">
            {t("gotoUser")}
          </Button>
        </Link>
      )}
    </div>
  );

  const getCreatedDetails = (item) => (
    <div className="flex items-center gap-3">
      {t("userCreated")}: {item.first_name} {item.last_name}
      {item?.uuid && (
        <Link to={`users/edit/${item.uuid}`} target="_blank">
          <Button type="button" size="xs">
            {t("gotoUser")}
          </Button>
        </Link>
      )}
    </div>
  );

  const getErrorDetails = (item) => (
    <div className="editor-user-modal-error-details">{t(item.status)}</div>
  );

  const getStatusCount = () => {
    const statusCount = {
      created: 0,
      alreadyExist: 0,
      errors: 0,
    };

    const created = [];
    const alreadyExist = [];
    const errors = [];

    users.map((user) => {
      switch (user.status) {
        case "created":
          statusCount.created++;
          created.push(user);
          break;
        case "already_exist":
          statusCount.alreadyExist++;
          alreadyExist.push(user);
          break;
        case "error":
        case "invalid_custom_values":
          statusCount.errors++;
          errors.push(user);
          break;
        default:
          break;
      }
    });

    setStatusCount(statusCount);
  };

  const tabsTriggerClassNames = cn("after:bg-primary text-base");

  return (
    <div className="editor-user-modal-container">
      <div className="flex gap-5">
        <Tabs
          onValueChange={(value) => setValue(value)}
          value={value}
          orientation="vertical"
        >
          <TabsList variant="line">
            <TabsTrigger value={0} className={tabsTriggerClassNames}>
              <div className="flex w-full items-center justify-between gap-3">
                <div>{t("created")}</div>
                <div className="flex size-6 items-center justify-center rounded-full bg-green-400 text-sm text-white">
                  {statusCount.created}
                </div>
              </div>
            </TabsTrigger>
            <TabsTrigger value={1} className={tabsTriggerClassNames}>
              <div className="flex w-full items-center justify-between gap-3">
                <div>{t("alreadyExist")}</div>
                <div className="flex size-6 items-center justify-center rounded-full bg-blue-800 text-sm text-white">
                  {statusCount.alreadyExist}
                </div>
              </div>
            </TabsTrigger>
            <TabsTrigger value={2} className={tabsTriggerClassNames}>
              <div className="flex w-full items-center justify-between gap-3">
                <div>{t("error")}</div>
                <div className="flex size-6 items-center justify-center rounded-full bg-red-600 text-sm text-white">
                  {statusCount.errors}
                </div>
              </div>
            </TabsTrigger>
          </TabsList>
        </Tabs>
        {renderPanel(value)}
      </div>
    </div>
  );
}

UsersAdminCardModal.propTypes = {
  users: PropTypes.array,
  t: PropTypes.func.isRequired,
};

export default withTranslation(["editor-users", "languages"])(
  UsersAdminCardModal,
);
